import type { IPlatformData } from '@wix/editor-elements-integrations';
import { withCompController } from '@wix/editor-elements-integrations';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import type {
  IMenuMapperProps,
  IMenuControllerProps,
  IMenuStateRefs,
} from '../Menu.types';

export const useComponentProps = ({
  mapperProps,
  stateValues,
}: IPlatformData<IMenuMapperProps, IMenuControllerProps, IMenuStateRefs>) => {
  const { currentUrl, experiments = {} } = stateValues;

  const isCssPreHydrationEnabled = isExperimentOpen(
    experiments,
    'specs.thunderbolt.cssMegaMenuPreHydration',
  );

  return {
    ...mapperProps,
    currentUrl,
    isCssPreHydrationEnabled,
  };
};

export default withCompController(useComponentProps);
